module.exports = __webpack_public_path__ + "assets/e1cb4f6ffddb32e76aba0b1211c92879.svg";